import axios from 'axios';
import https from 'https';
import Telegram from '../error-handler/helper/Telegram';

const checkHttpsCertificate = process.env.NODE_ENV === 'production';

const proxyAxios = axios.create({
  // baseURL: 'https://www.searates.com/',
  // baseURL: 'https://develop.searates.dev/',
  baseURL: process.env.API_URL,
  // withCredentials: true,
  httpsAgent: new https.Agent({
    rejectUnauthorized: checkHttpsCertificate,
  }),
  timeout: 180000
});

const jsonHandler = (data: any) => {
  return JSON.stringify(data, null, 2)
    .replace(/_/g, '\_')
    .replace(/\*/g, '\*')
    .replace(/\[/g, '\[')
    .replace(/\]/g, '\]')
    .replace(/\(/g, '\(')
    .replace(/\)/g, '\)')
    .replace(/~/g, '\~')
    .replace(/`/g, '\`')
    .replace(/>/g, '\>')
    .replace(/#/g, '\#')
    .replace(/\+/g, '\+')
    .replace(/-/g, '\-')
    .replace(/=/g, '\=')
    .replace(/\|/g, '\|')
    .replace(/\{/g, '\{')
    .replace(/\}/g, '\}')
    .replace(/\./g, '\.')
    .replace(/!/g, '\!');
}

const statusTexts = ['Unauthorized', 'Forbidden'];
const statusLabelsBlock = ["Your phone number is already verified", "Public email domains are not allowed"];

const errorHandler = async (error: any) => {
  try {
    if(error?.config?.data) {
      try {
        if(typeof error.config.data === 'string') {
          const parsed = JSON.parse(error.config.data);
          if (parsed.password) parsed.password = '[REDACTED]';
          if (parsed.confirmPassword) parsed.confirmPassword = '[REDACTED]';
          error.config.data = JSON.stringify(parsed);
        } else if (typeof error.config.data === 'object' && error.config.data !== null) {
          const clonedData = { ...error.config.data };
          if (clonedData.password) clonedData.password = '[REDACTED]';
          if (clonedData.confirmPassword) clonedData.confirmPassword = '[REDACTED]';
          error.config.data = clonedData;
        }
      } catch (scrubError) {
        error.config.data = '[REDACTED]';
      }
    }

    if (statusTexts.includes(error?.response?.statusText)) {
      return Promise.reject(error);
    }

    let rawData: any = {};

    if (error?.config?.data) {
      rawData = typeof error.config.data === 'string' 
        ? JSON.parse(error.config.data) 
        : error.config.data;
    }

    const { password, confirmPassword, ...data } = rawData;

    if (data['g-recaptcha-response']) delete data['g-recaptcha-response'];

    const path = error?.request?.path || error?.config?.url || '';
    const payload = jsonHandler(data);
    let errorMessage = jsonHandler(error?.response?.data || '');

    if (statusLabelsBlock.some((label) => errorMessage.includes(label))) return Promise.reject(error);

    let string = `
[API ERROR]

PATH: ${path || ''}
METHOD: ${error?.config?.method?.toUpperCase() || ''}
STATUS: ${String(error?.response?.status || '')}

PAYLOAD:
${payload || '{}'}

RESPONSE:
${errorMessage || ''}
  `;

    process.env.NODE_ENV === 'production' && (await new Telegram('error').send(string));
  } catch (e) {
    process.env.NODE_ENV === 'production' && (await new Telegram('error').send(JSON.stringify(e)));
  }

  return Promise.reject(error);
};

proxyAxios.interceptors.request.use((config) => config, errorHandler);
proxyAxios.interceptors.response.use((response) => response, errorHandler);

type TUser = {
  profile: number | string;
  hash: string;
};

export const setToken = (user: TUser) => {
  if (user) {
    const token = getToken(user);
    proxyAxios.defaults.headers.common['Authorization'] = `Basic ${token}`;
  }
};

export const getToken = (user: TUser) => {
  return btoa(`${user.profile}:${user.hash}`);
};

export default proxyAxios;
